import { render, staticRenderFns } from "./LeccionB5.vue?vue&type=template&id=2f371542&"
import script from "./LeccionB5.vue?vue&type=script&lang=js&"
export * from "./LeccionB5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports